/** Canonical org-admin role name (Spring Security authority: ROLE_ORG_ADMIN). */
export const ORG_ADMIN_ROLE = 'ORG_ADMIN';

const LEGACY_ORG_ADMIN_NAMES = new Set(['ADMIN', 'ROLE_ADMIN', 'ORG_ADMIN', 'ROLE_ORG_ADMIN']);

/** @param {string | { name?: string }} role */
export function isOrgAdminRole(role) {
  const name = typeof role === 'string' ? role : (role?.name || '');
  return LEGACY_ORG_ADMIN_NAMES.has(name);
}

/** Prefer API displayName; fall back to formatted role id. */
export function getRoleLabel(role) {
  if (!role) return '';
  if (typeof role === 'string') return formatRoleName(role);
  return role.displayName || formatRoleName(role.name);
}

/** Human-readable label for a role name or authority. */
export function formatRoleName(name) {
  if (!name) return '';
  const normalized = name.replace(/^ROLE_/, '');
  if (normalized === 'ORG_ADMIN' || normalized === 'ADMIN') return 'Org admin';
  if (normalized === 'SYSTEM_ADMIN') return 'System Admin';
  if (normalized === 'PROC_OPR') return 'Purchase Operator';
  if (normalized === 'PROC_MGR') return 'Purchase Manager';
  if (normalized === 'QC_INSPECTOR') return 'Quality Check Inspector';
  if (normalized === 'OQ_MGR') return 'Quality Check Manager';
  return normalized
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
}
